import React from "react";
import { Link } from "react-router-dom";
import languageKeys from "../translations";
import {
  FileAddOutlined,
  HistoryOutlined,
  LinkOutlined,
  MobileOutlined,
  FileImageOutlined,
  KeyOutlined,
  HomeOutlined,
  DashboardOutlined,
} from "@ant-design/icons";

const links = (state, translate) => ({
  welcome: (
    <Link to="/admin/welcome">
      <HomeOutlined /> &nbsp;
      <span>{translate(languageKeys.welcome)}</span>
    </Link>
  ),
  prescriberDashboard: (
    <Link to="/prescriber/dashboard">
      <DashboardOutlined /> &nbsp;
      <span>{translate(languageKeys.prescriber_dashboard)}</span>
    </Link>
  ),
  gallery: (
    <Link to="/admin/gallery">
      <span>{translate("gallery")}</span>
    </Link>
  ),
  reports: (
    <Link to="/admin/reports">
      <span>{translate(languageKeys.reports)}</span>
    </Link>
  ),
  customTexts: (
    <Link to="/admin/custom-texts">
      <span>{translate(languageKeys.customTexts)}</span>
    </Link>
  ),
  emailTemplates: (
    <Link to="/admin/email-templates">
      <span>{translate(languageKeys.emailTemplates)}</span>
    </Link>
  ),
  pushNotifications: (
    <Link to="/admin/push-notifications">
      <span>{translate("push_notifications")}</span>
    </Link>
  ),
  backofficeValues: (
    <Link to="/admin/backoffice-values">
      <KeyOutlined />
      <span>{translate(languageKeys.settingsMenu)}</span>
    </Link>
  ),
  character: (
    <Link to="/admin/characters">
      <span>{translate(languageKeys.characterMenu)}</span>
    </Link>
  ),
  season: (
    <Link to="/admin/seasons">
      <span>{translate(languageKeys.seasonMenu)}</span>
    </Link>
  ),
  naturalElement: (
    <Link to="/admin/natural-elements">
      <span>{translate(languageKeys.naturalElementMenu)}</span>
    </Link>
  ),
  criteria: (
    <Link to="/admin/criteria">
      <span>{translate(languageKeys.criteriaMenu)}</span>
    </Link>
  ),
  criteriaUsage: (
    <Link to="/admin/criteria-usage">
      <span>{translate(languageKeys.criteriaUsageMenu)}</span>
    </Link>
  ),
  metaSkill: (
    <Link to="/admin/meta-skill">
      <span>{translate(languageKeys.metaSkillMenu)}</span>
    </Link>
  ),
  principle: (
    <Link to="/admin/principle">
      <span>{translate(languageKeys.principleMenu)}</span>
    </Link>
  ),
  element: (
    <Link to="/admin/elements">
      <span>{translate(languageKeys.elementMenu)}</span>
    </Link>
  ),
  feeling: (
    <Link to="/admin/feelings">
      <span>{translate(languageKeys.feelingsMenu)}</span>
    </Link>
  ),
  organ: (
    <Link to="/admin/organs">
      <span>{translate(languageKeys.organsMenu)}</span>
    </Link>
  ),
  algorithmOutput: (
    <Link to="/admin/algorithm-output">
      <span>{translate(languageKeys.algorithmOutputMenu)}</span>
    </Link>
  ),
  generalOutput: (
    <Link to="/admin/general-output">
      <span>{translate(languageKeys.generalOutputMenu)}</span>
    </Link>
  ),
  input: (
    <Link to="/admin/input">
      <FileImageOutlined />
      <span>{translate(languageKeys.inputMenu)}</span>
    </Link>
  ),
  app: (
    <Link to="/admin/mobile-apps">
      <MobileOutlined />
      <span>{translate(languageKeys.mobileApkMenu)}</span>
    </Link>
  ),
  // pushNotifications: (
  //   <Link to="/admin/push-notifications">
  //     <NotificationOutlined />
  //     <span>{translate(languageKeys.pushNotificationsMenu)}</span>
  //   </Link>
  // ),
  questionnaires: (
    <Link to="/admin/questionnaires">
      <span>{translate(languageKeys.questionnairesMenu)}</span>
    </Link>
  ),
  usersBackoffice: (
    <Link to="/admin/users/backoffice">
      <span>{translate(languageKeys.userBackofficeMenu)}</span>
    </Link>
  ),
  usersApp: (
    <Link to="/admin/users/app">
      <span>{translate(languageKeys.userAppMenu)}</span>
    </Link>
  ),
  pacients: (
    <Link to="/admin/pacients">
      <span>{translate(languageKeys.pacients)}</span>
    </Link>
  ),
  prescribers: (
    <Link to="/admin/prescribers">
      <span>{translate(languageKeys.companyUsersMenu)}</span>
    </Link>
  ),
  companies: (
    <Link to="/admin/companies">
      <span>{translate(languageKeys.companies)}</span>
    </Link>
  ),
  questions: (
    <Link to="/admin/questions">
      <span>{translate(languageKeys.questionsMenu)}</span>
    </Link>
  ),
  answersOptions: (
    <Link to="/admin/answers-options">
      <span>{translate(languageKeys.answer_options)}</span>
    </Link>
  ),
  textConfigCriteria: (
    <Link to="/admin/text-config/criteria">
      <span>{translate(languageKeys.criteriaMenu)}</span>
    </Link>
  ),
  textConfigCriteriaUsage: (
    <Link to="/admin/text-config/criteria-usage">
      <span>{translate(languageKeys.criteriaUsageMenu)}</span>
    </Link>
  ),
  textConfigMetaSkill: (
    <Link to="/admin/text-config/meta-skill">
      <span>{translate(languageKeys.metaSkillMenu)}</span>
    </Link>
  ),
  textConfigPrinciple: (
    <Link to="/admin/text-config/principle">
      <span>{translate(languageKeys.principleMenu)}</span>
    </Link>
  ),
  textConfigElement: (
    <Link to="/admin/text-config/element">
      <span>{translate(languageKeys.elementMenu)}</span>
    </Link>
  ),
  textConfigFeeling: (
    <Link to="/admin/text-config/feeling">
      <span>{translate(languageKeys.feelingsMenu)}</span>
    </Link>
  ),
  textConfigOrgan: (
    <Link to="/admin/text-config/organ">
      <span>{translate(languageKeys.organsMenu)}</span>
    </Link>
  ),
  textConfigSeason: (
    <Link to="/admin/text-config/season">
      <span>{translate(languageKeys.seasonMenu)}</span>
    </Link>
  ),
  textConfigNaturalElement: (
    <Link to="/admin/text-config/natural-element">
      <span>{translate(languageKeys.naturalElementMenu)}</span>
    </Link>
  ),
  textConfigCharacter: (
    <Link to="/admin/text-config/character">
      <span>{translate(languageKeys.characterMenu)}</span>
    </Link>
  ),
  invites: (
    <Link to="/admin/invites">
      <LinkOutlined /> &nbsp;
      <span>{translate(languageKeys.invitesMenu)}</span>
    </Link>
  ),
  answerQuestionnaire: (
    <Link
      to={{
        pathname: `/user/${state.userId}/answer-questionnaire`,
        state: { userId: state.userId },
      }}
    >
      <FileAddOutlined /> &nbsp;
      <span>{translate(languageKeys.questionnaire)}</span>
    </Link>
  ),
  consultantInvite: (
    <Link
      to={{
        pathname: `/user/${state.userId}/answer-questionnaire`,
        state: { userId: state.userId },
      }}
    >
      <FileAddOutlined /> &nbsp;
      <span>{translate(languageKeys.invite)}</span>
    </Link>
  ),
  history: (
    <Link
      to={{
        pathname: `/user/${state.userId}/answer-questionnaire/history`,
        state: { userId: state.userId },
      }}
    >
      <HistoryOutlined /> &nbsp;
      <span>{translate(languageKeys.history)}</span>
    </Link>
  ),
  criteriaManagement: (
    <Link
      to={{
        pathname: `/admin/criteria-management`,
        state: { userId: state.userId },
      }}
    >
      <span>{translate(languageKeys.criteriaManagementMenu)}</span>
    </Link>
  ),
  algorithmConfig: (
    <Link
      to={{
        pathname: `/admin/algorithm-config`,
        state: { userId: state.userId },
      }}
    >
      <span>{translate("algorithm_config")}</span>
    </Link>
  ),
});

export default links;
